import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { TableCell, TableRow } from '@mui/material';
import clsx from 'clsx';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ArtworkCol from 'commons/ArtworkCol';
import Text from 'commons/Text';
import { getLabelForOption, STATUS_REQUEST_KEY } from 'configs/Constant';
import Routes from 'utils/Route';
import { formatCurrency } from 'utils/utils';

import DisplayData from '../../Common/DisplayData';
import DialogAddInventory from '../DialogAddInventory';
import useStyles from './styles';

const NewArrivalRow = ({ artwork }) => {
  const classes = useStyles();
  const [isShowDialogAddInventory, setIsShowDialogAddInventory] = useState(false);
  const language = useSelector((state) => state?.language?.currentLanguage);
  const navigate = useNavigate();
  const { artist_tag_request, artist_artwork } = artwork || {};

  const { status, request_to } = artist_tag_request || {};

  const priceFormat = formatCurrency(artwork?.price);

  const getTextArtistName = () => {
    if (!artist_artwork?.artist_name && !request_to?.id) {
      return 'N/A';
    }

    if (request_to?.id) {
      return request_to?.name;
    }

    return artist_artwork?.artist_name;
  };

  const getSizeData = (size) => {
    const { height, width, depth } = size || {};

    if (!height || !width) return null;

    return `${height} x ${width}${depth ? ` x ${depth}` : ''} cm`;
  };

  const sizeData = getSizeData(artwork?.size);

  const handleNavigateToGallery = () => {
    if (status !== STATUS_REQUEST_KEY.REQUEST_APPROVED) {
      return;
    }

    navigate(Routes.GalleryDetail(request_to?.uuid));
  };

  const handleNavigateArtworkDetail = () => {
    navigate(Routes.ArtworkDetail(artwork?.id));
  };

  const handleOpenDialogAddInventory = () => {
    setIsShowDialogAddInventory(true);
  };

  const handleCloseDialogAddInventory = () => {
    setIsShowDialogAddInventory(false);
  };

  return (
    <TableRow>
      <TableCell onClick={handleNavigateArtworkDetail}>
        <ArtworkCol
          id={artwork?.id}
          image={artwork?.images[0]}
          title={artwork?.title}
          isLink
        />
      </TableCell>
      <TableCell>
        <Text
          type="sm"
          clickAble={artwork?.artist?.name}
          onClick={handleNavigateToGallery}
          className={clsx(classes.textArtist, {
            [classes.textArtistStatusApprove]: status === STATUS_REQUEST_KEY.REQUEST_APPROVED,
          })}
        >
          {getTextArtistName()}
        </Text>
      </TableCell>
      <DisplayData value={getLabelForOption(artwork?.medium, language)} />
      <DisplayData value={artwork?.year_created || artwork?.period_created} />
      <DisplayData value={sizeData} />
      <DisplayData value={priceFormat ? `${priceFormat} ${artwork?.currency}` : null} />
      <DisplayData value={moment(artwork?.in_stock_date).format('DD/MM/YYYY')} />
      <DisplayData value={artwork?.inventory_code} />
      <DisplayData value={artwork?.location?.location} />
      <DisplayData value={artwork?.status?.value} />
      <TableCell>
        <AddCircleOutlineIcon
          onClick={handleOpenDialogAddInventory}
          className={classes.iconAddInventory}
        />

        <DialogAddInventory
          isShowDialog={isShowDialogAddInventory}
          artwork={artwork}
          onClose={handleCloseDialogAddInventory}
        />
      </TableCell>
    </TableRow>
  );
};

export default NewArrivalRow;
